import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { useTable } from "react-table";
import SquareCheckBox from "components/SquareCheckBox/index";
import MenuDropDown from "components/DropDowns/MenuDropDown/index";
import {
  menuList,
  trashList,
  sharedMenuList
} from "constants/Homepage/ysafe/menuList/list";

// import Tabs from "components/Tabs/index";
// import TabIcons from "constants/Homepage/ysafe/iconFunctions/tabIcons";
import ActionIcon from "constants/Homepage/ysafe/iconFunctions/actionIcon";
import useScreenMobile from "hooks/useScreen";

import folder from "../../../../assets/images/homepage/ySafe/tableIcons/folder.svg";
import pdf from "../../../../assets/images/homepage/ySafe/tableIcons/pdf.svg";
import xls from "../../../../assets/images/homepage/ySafe/tableIcons/xls.svg";

import "./table.scss";
import addFile from "assets/images/homepage/ySafe/addFile.png";
import GetActionIcon from "constants/Homepage/ysafe/iconFunctions/getActionIcon";
import RenameFile from "components/RenameFile/index";
import Drawer from "components/Drawer/index";
import ShareProject from "../ShareProject/index";
import ExternalSpaceModal from "../ExternalSpaceModal/index";
// import FileInformation from "../FileInformation/index";
import VersionHistory from "../VersionHistory/index";
import DeleteModal from "components/DeleteModal/index";
import MoveFile from "components/MoveFile/index";
import ShareFiles from "../shareFiles/index";
import docs from "assets/images/fileImage/docs.svg";
import idoc from "assets/images/fileImage/idoc.svg";
import isheet from "assets/images/fileImage/isheet.png";
import jpf from "assets/images/fileImage/jpg.svg";
import zip from "assets/images/homepage/ySafe/zip.svg";
import commonIcon from "assets/images/homepage/ySafe/commonFile.svg";
import ListIcons from "constants/Homepage/ysafe/menuList/listIconsFunc";
import Portal from "../Portal";
import RestoreModal from "components/RestoreModal/index";
import BreadCrumb from "./BreadCrum/index";
import Files from "../FileInformation/index";
import { File as IzFile, Folder as IzFolder } from "@induz/sdk";
import GridThumbnail from "components/GridThumbnail/index";
import { Item, Task } from "@induz/sdk";
import { useToast } from "components/Toaster/index";
import useTheme from "hooks/observer";
import CollaboraUI from "containers/CollaboraUI/CollaboraUI";
import { COLLABORA_URL, WOPI_URL, COLLABORA_STATE } from "URL/url";
import { getPin, getEmail } from "@induz/sdk";
import { normalizeName } from "utils/normalizeName";
import {
  fetchUserPlanTrashRetentionDays,
  formatTrashRetentionBanner
} from "utils/planTrashRetention";
import PDFViewer from "components/PDFViewer/index";
import ImageViewer from "components/ImageViewer/index";
import AudioPlayer from "components/AudioPlayer/index";

import VideoPlayer from "components/VideoPlayer/index";
import { createNode } from "../../../../../node_modules/yet-another-react-lightbox/dist/index";

const CHUNK_TIMEOUT = 60000; // 60s per 4MB chunk
const MAX_CHUNK_RETRIES = 3;

const withTimeout = (promise, ms, label = "Operation") => {
  let timeoutId;
  const timeoutPromise = new Promise((_, reject) => {
    timeoutId = setTimeout(
      () => reject(new Error(`${label} timed out after ${ms}ms`)),
      ms
    );
  });
  return Promise.race([promise, timeoutPromise]).finally(() =>
    clearTimeout(timeoutId)
  );
};

// URLs for standalone apps
const SHEETS_APP_URL = "https://ysafe.io/sheets/";
const DOCS_APP_URL = "https://ysafe.io/docs/";

// Function to get file icon based on extension
const getFileIcon = (fileName, type) => {
  if (type === "folder") {
    return folder;
  }
  const extension = fileName?.split(".").pop().toLowerCase();
  switch (extension) {
    case "xls":
    case "xlsx":
    case "csv":
      return xls;
    case "pdf":
      return pdf;
    case "doc":
    case "docx":
      return docs;
    case "idoc":
      return idoc;
    case "isheet":
      return isheet;
    case "jpg":
    case "png":
    case "jpeg":
    case "svg":
      return jpf;
    case "zip":
      return zip;
    default:
      return commonIcon;
  }
};



const getAudioMimeType = (extension) => {
  const map = {
    mp3: "audio/mpeg",
    wav: "audio/wav",
    ogg: "audio/ogg; codecs=\"vorbis\"",
    m4a: "audio/mp4; codecs=\"mp4a.40.2\"",
    flac: "audio/flac"
  };
  return map[extension] || `audio/${extension}`;
};

const tabsTitles = [
  // "Recent",
  "All Files",
  "Shared with me",
  // "Favourites",
  "Trash"
];

const actionIconTitles = [
  "moveTo",
  "copy",
  "favorite",
  "download",
  "share",
  "restore",
  "delete"
];

// const tabIconKeys = ["allFiles", "shared", /* "favourite", */ "trash"];
// const tabIconKeys = ["recent", "allFiles", "shared", "favourite", "trash"];

const Table = ({
  setTaskMonitorVisible,
  layout,
  folder,
  count,
  setCount,
  checkedRows,
  setCheckedRows,
  filesData,
  searchQuery,
  uploadedFiles,
  setFilesData,
  selected,
  filteredFilesData,
  selectedRow,
  setSelectedRow,
  activeTab,
  setActiveTab,
  menu,
  setMenu,
  selectedModal,
  setSelectedModal,
  setCurrentPath,
  currentPath,
  fetchData,
  setSelectedFolder,
  selectedFolder,
  setSelectedFile,
  setModal,
  setFilesList,
  modal,
  taskManager,
  currentPage,
  setCurrentPage,
  totalPages,
  listedFolders,
  getReanderingList,
  showSharedTab = true,
  backendOperations,
  isOrganisationUser,
  hasSpacePermission = true
}) => {
  const showToast = useToast();
  const theme = useTheme();
  const [isAllChecked, setIsAllChecked] = useState(false);
  // Check if we're at root level of "Shared with me" tab
  const isSharedWithMeRoot = tabsTitles[activeTab] === "Shared with me" && currentPath.length <= 1;
  //   const [activeTab, setActiveTab] = useState(0);
  const [mobileRow, setMobileRow] = useState();
  //   const [selectedModal, setSelectedModal] = useState(null);
  const [subDropDown, setSubDropDown] = useState(false);
  const isMobile = useScreenMobile({ size: 768 });
  
  // Update isAllChecked when filesData or checkedRows changes
  useEffect(() => {
    if (filesData && filesData.length > 0) {
      const allChecked = filesData.every(file => file.name in checkedRows);
      setIsAllChecked(allChecked);
    } else {
      setIsAllChecked(false);
    }
  }, [filesData, checkedRows]);
  const [isEnoughSpaceBelow, setIsEnoughSpaceBelow] = useState(true);
  const [gridMenuPosition, setGridMenuPosition] = useState({ top: 0, right: 0, left: null, isFixed: false });
  const [tableMenuPosition, setTableMenuPosition] = useState({ top: null, right: null, left: null });

  const [dupCurrentPath, setdupCurrentPath] = useState([]);
  const [UUIDArrays, setUUIDArrays] = useState([]);

  const [showCollabora, setShowCollabora] = useState(false);
  const collaboraURL = useRef("");

  const [showAudioPlayer, setShowAudioPlayer] = useState(false);
  const [audioFo, setAudioFo] = useState(null);
  const [audioFileName, setAudioFileName] = useState("");
  const [audioDupCurrentPath, setAudioDupCurrentPath] = useState([]);

  const [showVideoPlayer, setShowVideoPlayer] = useState(false);
  const [videoFo, setVideoFo] = useState(null);
  const [videoFileName, setVideoFileName] = useState("");
  const [videoDupCurrentPath, setVideoDupCurrentPath] = useState([]);

  const [showPDFViewer, setShowPDFViewer] = useState(false);
  const [pdfFo, setPdfFo] = useState(null);
  const [pdfFileName, setPdfFileName] = useState("");
  const [pdfDupCurrentPath, setPdfDupCurrentPath] = useState([]);

  const [showImageViewer, setShowImageViewer] = useState(false);
  const [imageFo, setImageFo] = useState(null);
  const [imageFileName, setImageFileName] = useState("");
  const [imageDupCurrentPath, setImageDupCurrentPath] = useState([]);

  const [fileOwner, setFileOwner] = useState("NoData");
  const [trashRetentionBanner, setTrashRetentionBanner] = useState(() =>
    formatTrashRetentionBanner(null)
  );

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const days = await fetchUserPlanTrashRetentionDays();
        if (!cancelled) setTrashRetentionBanner(formatTrashRetentionBanner(days));
      } catch {
        if (!cancelled) setTrashRetentionBanner(formatTrashRetentionBanner(null));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const hasBackendOperationData = Array.isArray(backendOperations) && backendOperations.length > 0;
  const backendOperationSet = useMemo(() => {
    if (!hasBackendOperationData) {
      return new Set();
    }
    return new Set(backendOperations.map((operation) => String(operation)));
  }, [backendOperations, hasBackendOperationData]);

  const hasBackendOperationPermission = (operationId) => {
    if (operationId === undefined || operationId === null) {
      return true;
    }
    return backendOperationSet.has(String(operationId));
  };

  const filterShareFromMenu = (items, row) => {
    // Permission ID mapping
    const PERMISSIONS = {
      "Rename": 1,
      "Copy to": 2,
      "Move to": 3,
      "Trash": 4, // "Trash" is the label used in menuList for moving to trash
      "Share": 5,
      "Download": 6,
      "File Information": 12,
      "Details": 12,
      "Restore": 14,
      "Delete forever": 15,
      "Versions": 16,
      "Add to Space": 37
    };

    let list = items;

    // Filter by tab/type
    if (!showSharedTab) {
      list = list.filter((item) => item.text !== "Share");
    }
    if (row?.type === "file") {
      list = list.filter((item) => item.text !== "Add to Space");
    }

    // Match Homepage Spaces visibility: org users without space operations cannot add to a space.
    if (isOrganisationUser && !hasSpacePermission) {
      list = list.filter((item) => item.text !== "Add to Space");
    }

    // In "Shared with me", keep the standard shared menu visible
    // (Copy to, Download, File Information) like org admin flow.
    // Do not apply owner-based backend operation filtering here.
    const isSharedTab = activeTab + 1 === 2;
    if (isSharedTab) {
      return list;
    }

    // Filter by backendOperations for organization users
    if (isOrganisationUser && hasBackendOperationData) {
      const email = getEmail() || sessionStorage.getItem("mail");
      const isOwner = row?.owner === "you" || (email && row?.owner === email);

      // If not the owner, strictly filter by allowed backend operations
      if (!isOwner) {
        list = list.filter(item => {
          const opId = PERMISSIONS[item.text];
          if (opId === undefined) return true; // If not in mapping, allow it
          return hasBackendOperationPermission(opId);
        });
      }
    }

    return list;
  };

  const getMenuItemsForRow = (row) => {
    const isTrashTab = activeTab + 1 === 3;
    const isSharedTab = activeTab + 1 === 2;
    const baseList = isTrashTab ? trashList : isSharedTab ? sharedMenuList : menuList;
    return filterShareFromMenu(baseList, row);
  };

  // No longer needed: New file creation state moved to new tabs

  // Listen for createNewFile event from AddFile component
  useEffect(() => {
    const handleCreateNewFile = (event) => {
      const { type, fileName, parentPath } = event.detail;
      console.log("[TableTest] Creating new file:", type, fileName, parentPath);

      if (type === 'doc') {
        const fullPath = `${parentPath}/${fileName}`.replace(/\/+/g, '/');
        window.open(`${DOCS_APP_URL}?path=${encodeURIComponent(fullPath)}&name=${encodeURIComponent(fileName)}&isNew=true`, "_blank");
      } else if (type === 'sheet') {
        const fullPath = `${parentPath}/${fileName}`.replace(/\/+/g, '/');
        window.open(`${SHEETS_APP_URL}?path=${encodeURIComponent(fullPath)}&name=${encodeURIComponent(fileName)}&isNew=true`, "_blank");
      }
    };

    window.addEventListener('createNewFile', handleCreateNewFile);
    return () => window.removeEventListener('createNewFile', handleCreateNewFile);
  }, []);
  // Pagination states (unique to TableTest)

  useEffect(() => {
    if (currentPath.length === 0) {
      setdupCurrentPath([]);
    }
  }, [currentPath]);


  useEffect(() => {
    if (filesData && Array.isArray(filesData)) {
      const uuidsArr = filesData.map(file => file.uuids).filter(Boolean);
      // console.log("UUIDarrays in table text.js", uuidsArr);
      setUUIDArrays(uuidsArr);
    }
  }, [filesData]);

  useEffect(() => {
    if (currentPath.length === 0 && activeTab + 1 === 2) {
      setCurrentPath((prev) => (prev.includes("shared") ? prev : [...prev, "shared"]));
    }
  }, [activeTab, currentPath, setCurrentPath]);
  const handledupFolderClick = (folderName) => {
    setdupCurrentPath((prev) => [...prev, folderName]);
  };
  const handleFolderClick = (folderName) => {
    setCurrentPath((prev) => [...prev, folderName]);

  };

  // Listen for file-open events from the Advanced Search modal
  useEffect(() => {
    const handleAdvSearchOpenFile = async (e) => {
      const { fullPath, parentPath, fileName, owner } = e.detail;
      const fileExtension = fileName?.split(".").pop()?.toLowerCase();
      // console.log("fullPath", fullPath);
      // console.log("parentPath", parentPath);
      // console.log("fileName", fileName);
      // console.log("owner", owner);
      // console.log("fileExtension", fileExtension);
      try {
        const fo = await Item.getItem(fullPath);
        if (fo instanceof IzFile) {
          const fileType = fo.getFileType();
          const parentParts = (parentPath || "").split("/").filter(Boolean);
          const dupPath = parentParts;

          if (fileType === "application/pdf" || fileExtension === "pdf") {
            setPdfFo(fo);
            setFileOwner(owner ?? "NoData");
            setPdfFileName(fileName);
            setPdfDupCurrentPath(dupPath);
            setShowPDFViewer(true);
          } else if (fileType === "application/idoc" || fileExtension === "idoc") {
            const normalizedPath = fullPath.replace(/\/+/g, "/");
            window.open(`${DOCS_APP_URL}?path=${encodeURIComponent(normalizedPath)}&name=${encodeURIComponent(fileName)}`, "_blank");
          } else if (fileType === "application/isheet" || fileExtension === "isheet") {
            const normalizedPath = fullPath.replace(/\/+/g, "/");
            window.open(`${SHEETS_APP_URL}?path=${encodeURIComponent(normalizedPath)}&name=${encodeURIComponent(fileName)}`, "_blank");
          } else if (["jpg", "jpeg", "png", "gif", "svg", "webp"].includes(fileExtension)) {
            setImageFo(fo);
            setFileOwner(owner ?? "NoData");
            setImageFileName(fileName);
            setImageDupCurrentPath(dupPath);
            setShowImageViewer(true);
          } else if (["mp3", "wav", "ogg", "m4a", "flac"].includes(fileExtension)) {
            setAudioFo(fo);
            setFileOwner(owner ?? "NoData");
            setAudioFileName(fileName);
            setAudioDupCurrentPath(dupPath);
            setShowAudioPlayer(true);
          } else if (["mp4", "webm", "ogv", "mov", "mkv"].includes(fileExtension)) {
            setVideoFo(fo);
            setFileOwner(owner ?? "NoData");
            setVideoFileName(fileName);
            setVideoDupCurrentPath(dupPath);
            setShowVideoPlayer(true);
          } else if (COLLABORA_STATE) {
            loadCollobora({ name: fileName });
          }
        }
      } catch (error) {
        console.error("Advanced search file open error:", error);
      }
    };
    window.addEventListener("advSearchOpenFile", handleAdvSearchOpenFile);
    return () => window.removeEventListener("advSearchOpenFile", handleAdvSearchOpenFile);
  }, []);
  //  const [menu, setMenu] = useState({
  //    selectedRow: null,
  //    selectedOption: ""
  //  });

  const handleSelectAll = (e) => {
    const isChecked = e?.target?.checked;
    const newCheckedRows = {};
    if (isChecked) {
      filesData.forEach((file) => {
        newCheckedRows[file.name] = file.uuids ?? -1;
      });
    }
    setSelectedModal(null);
    setCheckedRows(newCheckedRows);
    setIsAllChecked(isChecked);
  };

  const [mobileRowData, setMobileRowData] = useState({});
  const menuRef = useRef(null);

  // Calculate table menu position synchronously before paint to prevent visual jump
  // This refines the position based on actual rendered menu height
  useLayoutEffect(() => {
    if (layout === "table" && menu.selectedRow && menuRef.current) {
      try {
        const menuRect = menuRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const menuTop = menuRect.top;
        const distanceFromBottom = viewportHeight - menuTop;

        const requiredMenuSpace = 260;
        setIsEnoughSpaceBelow(distanceFromBottom >= requiredMenuSpace);
      } catch (error) {
        console.error("Error calculating table menu position:", error);
        setIsEnoughSpaceBelow(true); // Default to opening below for better visibility
      }
    }
  }, [menu.selectedRow, layout]);

  const columns = useMemo(
    () => {
      // Shared tab root (e.g. "self" folder): only Name column; no operations at this level
      if (isSharedWithMeRoot) {
        return [
          {
            Header: "Name",
            accessor: "name",
            width: "100%",
            Cell: ({ row }) => (
              <div className="nameColumn"
                onClick={() => setSelectedFolder(row.original)}
              >
                <img
                  src={getFileIcon(row.original.name, row.original.type)}
                  alt="file icon"
                  className="fileIcon"
                />
                <div className="iconNameBox">
                  <span className="name">{row.original.name || "NoData"}</span>
                </div>
              </div>
            )
          }
        ];
      }

      return [
        {
          Header: () => (
            <SquareCheckBox
              label=""
              isChecked={isAllChecked}
              isDisable={false}
              onChange={handleSelectAll}
            />
          ),
          accessor: "id",
          Cell: ({ row }) => (
            <SquareCheckBox
              label=""
              isChecked={row.original.name in checkedRows}
              isDisable={false}
              onChange={(e) => {
                setCheckedRows((prev) => {
                  const temp = { ...prev };
                  if (row.original.name in temp) {
                    delete temp[row.original.name];
                  } else {
                    temp[row.original.name] = row.original.uuids ?? -1;
                  }
                  const updatedCheckedRows = {
                    ...temp
                  };

                  const allChecked =
                    Object.keys(updatedCheckedRows).length === filesData.length &&
                    filesData.length > 0;
                  setIsAllChecked(allChecked);

                  return updatedCheckedRows;
                });
              }}
            />
          ),
          width: "3%"
        },
        {
          Header: "Name",
          accessor: "name",
          width: "34%",
          Cell: ({ row, cells }) => {
            return (
              <div className="nameColumn">
                <img
                  src={getFileIcon(row.original.name, row.original.type)}
                  alt="file icon"
                  className="fileIcon"
                />
                <div className="iconNameBox">
                  <span className="name">{row.original.name || "NoData"}</span>
                </div>
              </div>
            );
          }
        },
        {
          Header: "Last Modified",
          accessor: "last_modified",
          width: "18%",
          Cell: ({ row, cells }) => (
            <span className="modified">
              {!isMobile && (
                <>
                  <div className="date">
                    {row.original.last_modified_date || "NoData"}
                  </div>
                  <div className="time">
                    {/* {new Date()
                    .toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true
                    })
                    .replace(" AM", " am")
                    .replace(" PM", " pm")} */}
                  </div>
                </>
              )}
              {/* Grid mode disabled for trash */}
              {layout == "grid" && activeTab + 1 !== 3 && (
                <div className="bytes">{row.original.size || "NoData"}</div>
              )}
            </span>
          )
        },
        {
          Header: "Size",
          accessor: "size",
          width: "12%",
          Cell: ({ row }) => (
            <span className="modified">
              {!isMobile && (
                <>
                  <div className="date">{row.original.size || " "}</div>
                  <div className="time">
                    {/* {new Date()
                    .toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true
                    })
                    .replace(" AM", " am")
                    .replace(" PM", " pm")} */}
                  </div>
                </>
              )}
              {/* Grid mode disabled for trash */}
              {layout == "grid" && activeTab + 1 !== 3 && (
                <div className="bytes">{row.original.size || "NoData"}</div>
              )}
            </span>
          )
        },
        {
          Header: "Owner",
          accessor: "owner",
          //   width: "24.2872%",
          width: "23%",
          Cell: ({ row }) => (
            <div
              className="ownerColumn"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "6px",
                fontSize: "12px"
              }}
            >
              {row.original.img ? (
                <img
                  src={row.original.img}
                  alt="profile"
                  className="ownerAvatar"
                />
              ) : (
                <div
                  style={{
                    height: "20px",
                    width: "20px",
                    background:
                      row.original.owner == "you"
                        ? "var(--fill-brand-light)"
                        : "var(--stroke-grey-medium)",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "10px"
                  }}
                >
                  <p>
                    {row?.original?.owner
                      ?.split(" ")
                      .map((word) => word[0])
                      .join("")}
                  </p>
                </div>
              )}
              <span>{row.original.owner || "NoData"}</span>
            </div>
          )
        },
        {
          Header: "Actions",
          accessor: "actions",
          width: "10%",
          //   width: "7.3582%",
          Cell: ({ row, column }) => (
            <div
              className="actionIconBox"
              onClick={(e) => {
                if (!e || !e.currentTarget) return;

                // For table view, calculate position BEFORE setting menu state
                // This prevents the dropdown from going down for last items
                if (layout === "table") {
                  try {
                    const actionIconRect = e.currentTarget.getBoundingClientRect();
                    const viewportHeight = window.innerHeight;
                    const actionIconBottom = actionIconRect.bottom;
                    const distanceFromBottom = viewportHeight - actionIconBottom;

                    // Use visible menu size instead of a fixed value so the last
                    // option (e.g. "Add to Space") is not clipped at 100% zoom.
                    const visibleMenuItems = getMenuItemsForRow(row?.original);
                    const menuItemHeight = 40; // includes row height + gaps
                    const menuVerticalPadding = 16;
                    const requiredMenuSpace = Math.max(
                      220,
                      (visibleMenuItems?.length || 0) * menuItemHeight + menuVerticalPadding
                    );
                    setIsEnoughSpaceBelow(distanceFromBottom >= requiredMenuSpace);
                    const menuTop = distanceFromBottom >= requiredMenuSpace
                      ? actionIconRect.bottom + 4
                      : Math.max(8, actionIconRect.top - requiredMenuSpace + actionIconRect.height);
                    setTableMenuPosition({
                      top: menuTop,
                      right: Math.max(8, window.innerWidth - actionIconRect.right + 8),
                      left: null
                    });
                  } catch (error) {
                    console.error("Error calculating table menu position:", error);
                    // Default to opening below to avoid clipping in upper rows
                    setIsEnoughSpaceBelow(true);
                    setTableMenuPosition({ top: null, right: null, left: null });
                  }
                }

                // Set the menu state
                setMobileRow(row.id);
                setMenu((prev) => ({ ...prev, selectedRow: row.id }));
                setMobileRowData(row?.original);
                // Ensure selectedRow is set for menu actions (Move, Copy, Share, Add to Space)
                setSelectedRow(row?.original);
                // Ensure selectedFolder is set for ShareProject component
                setSelectedFolder(row?.original);

                // For grid view, calculate position after state update
                // Grid mode disabled for trash
                if (layout === "grid" && activeTab + 1 !== 3) {
                  // Capture the bounding rect for grid view
                  let actionIconRect = null;
                  try {
                    if (e.currentTarget) {
                      actionIconRect = e.currentTarget.getBoundingClientRect();
                    }
                  } catch (error) {
                    console.error("Error getting action icon rect:", error);
                    return;
                  }

                  if (!actionIconRect) return;

                  setTimeout(() => {
                    try {
                      const menuHeight = 450; // Approximate menu height with all items
                      const menuWidth = 220; // Approximate menu width
                      const availableSpaceBelow = window.innerHeight - actionIconRect.bottom;
                      const availableSpaceRight = window.innerWidth - actionIconRect.right;
                      const padding = 10; // Padding from viewport edges

                      // Always open below (never above) to ensure all actions are visible
                      // Position to the right of the three-dots icon (like table view)
                      let menuTop = actionIconRect.bottom + 4;
                      let menuRight = window.innerWidth - actionIconRect.right + 8;

                      // If menu would go off screen at the bottom, adjust top position to fit
                      // But always keep it below the icon (never above)
                      if (availableSpaceBelow < menuHeight + padding) {
                        // Calculate maximum top position that keeps menu fully visible
                        const maxTop = window.innerHeight - menuHeight - padding;
                        // Shift up just enough to show all items, but keep it as close to below as possible
                        menuTop = Math.max(padding, Math.min(maxTop, actionIconRect.bottom + 4));
                      }

                      // If menu would go off screen on the right, adjust right position
                      // But try to keep it to the right of the icon (like table view)
                      if (availableSpaceRight < menuWidth + padding) {
                        // Shift left to fit, but keep it aligned to the right edge of viewport
                        menuRight = Math.max(padding, window.innerWidth - actionIconRect.right - menuWidth - 8);
                      }

                      setIsEnoughSpaceBelow(true);
                      setGridMenuPosition({
                        top: menuTop,
                        right: menuRight,
                        left: null,
                        isFixed: true
                      });
                    } catch (error) {
                      console.error("Error calculating menu position:", error);
                      // Fallback to default positioning
                      setIsEnoughSpaceBelow(true);
                      setGridMenuPosition({
                        top: actionIconRect.bottom + 4,
                        right: window.innerWidth - actionIconRect.right + 8,
                        left: null,
                        isFixed: true
                      });
                    }
                  }, 0);
                }
                // For table view, useLayoutEffect will handle the position calculation
              }}
              style={{
                cursor: "pointer",
                border:
                  checkedRows[row.original.name] &&
                  layout == "table" &&
                  "1px solid",
                borderColor:
                  checkedRows[row.original.name] && "var(--stroke-grey-medium)"
              }}
            >
              <ActionIcon
                type="action"
                //   color={
                //     layout == "grid" && theme == "dark"
                //       ? "var(--text-grey-neutral)"
                //       : "var(--text-highlight)"
                //   }
                color="var(--text-grey-neutral)"
              />
            </div>
          )
        }
      ];
    },
    [checkedRows, isAllChecked, layout, isMobile, activeTab, currentPath, isSharedWithMeRoot, filesData]
  );
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: filesData });

  const pressTimerRef = useRef(null);
  const isLongPress = useRef(false);
  const [isSelectionMode, setIsSelectionMode] = useState(false); // Tracks if selection mode is active

  const handleTouchStart = (event, id, uuid) => {
    // event.preventDefault(); // Prevents ghost clicks on mobile
    event.stopPropagation();

    isLongPress.current = false;

    pressTimerRef.current = setTimeout(() => {
      isLongPress.current = true;
      setIsSelectionMode(true); // Enable selection mode on long press

      setCheckedRows((prev) => {
        const updatedCheckedRows = { ...prev, [id]: uuid };
        const allChecked = Object.values(updatedCheckedRows).every(Boolean);
        setIsAllChecked(allChecked);
        return updatedCheckedRows;
      });
    }, 500); // Increased delay for better long-press detection
  };

  const handleTouchEnd = () => {
    clearTimeout(pressTimerRef.current);
  };

  const handleMobileRowClick = (rowId, uuid) => {
    if (!isSelectionMode) return; // Prevent selection if long press hasn't been used first

    if (isLongPress.current) {
      isLongPress.current = false; // Ignore click if it was a long press
      return;
    }

    setCheckedRows((prev) => {
      const updatedCheckedRows = { ...prev };

      if (rowId in updatedCheckedRows) {
        // Deselect row if already selected
        delete updatedCheckedRows[rowId];
      } else {
        // Select row if not selected
        updatedCheckedRows[rowId] = uuid;
      }

      // Check if all rows are deselected -> Reset selection mode
      if (Object.keys(updatedCheckedRows).length === 0) {
        setIsSelectionMode(false);
      }

      // Check if all rows are selected
      const filteredFilesData = Object.keys(updatedCheckedRows)
        .map((name) => filesData.find((item) => item.name === name))
        .filter(Boolean);

      const allChecked =
        filteredFilesData.length === filesData.length && filesData.length > 0;
      setIsAllChecked(allChecked);

      return updatedCheckedRows;
    });
  };

  const handleMenu = () => {
    setMenu({
      selectedRow: null,
      selectedOption: ""
    });
  };

  const handleCancelSubdropDown = () => {
    setSubDropDown(false);
  };

  useEffect(() => {
    setCount(Object.keys(checkedRows).length);
  }, [checkedRows]);

  // Defensive reset: if selection changes after an operation, stale copy/move modal state
  // must not auto-open again.
  useEffect(() => {
    if (selectedModal === "copy" || selectedModal === "moveTo") {
      setSelectedModal(null);
    }
  }, [checkedRows]);

  // const menuRef = useRef(null);

  const [rename, setRename] = useState("");
  const [fileExtension, setFileExtension] = useState("");

  useEffect(() => {
    if (selectedRow?.name) {
      const lastDotIndex = selectedRow.name.lastIndexOf(".");
      if (lastDotIndex !== -1 && lastDotIndex > 0) {
        // Extract name without extension
        const nameWithoutExt = selectedRow.name.substring(0, lastDotIndex);
        const ext = selectedRow.name.substring(lastDotIndex);
        setRename(nameWithoutExt);
        setFileExtension(ext);
      } else {
        // No extension case
        setRename(selectedRow.name);
        setFileExtension("");
      }
    }
  }, [selectedRow]);

  useEffect(() => {
    if (menu?.selectedOption === "Rename" && selectedRow?.name) {
      const lastDotIndex = selectedRow.name.lastIndexOf(".");
      if (lastDotIndex !== -1 && lastDotIndex > 0) {
        setRename(selectedRow.name.substring(0, lastDotIndex));
        setFileExtension(selectedRow.name.substring(lastDotIndex));
      } else {
        setRename(selectedRow.name);
        setFileExtension("");
      }
    }
  }, [menu?.selectedOption, selectedRow?.name]);

  useEffect(() => {
    setCheckedRows({});
    setIsAllChecked(false);
  }, [activeTab]);

  useEffect(() => {
    setCheckedRows({});
    setIsAllChecked(false);
  }, [currentPath]);

  const changeHandler = (e) => {
    const newValue = e.target.value.replace(/[^a-zA-Z0-9 _-]/g, "");
    setRename(newValue); // Only update the file name, not the extension
  };

  // const removeAfterRename = async () => {
  //   try {
  //     // await init();
  //     // const wasmInstance = new IzWasm(URL);
  //     // const sourcePath =
  //     //   currentPath.length > 0
  //     //     ? "/" + currentPath.join("/")
  //     //     : currentPath.join("/");
  //     // const remove = await wasmInstance.remove(localStorage.getItem("mail"), [
  //     //   sourcePath + "/" + selectedFolder.name
  //     // ]);

  //     console.log({ remove });
  //   } catch (error) {
  //     showToast("Error renaming file or folder : " + error, "error");
  //     console.log("Error renaming file or folder", error);
  //   }
  // };

  // using the move method to rename the folder or file

  /*
  Error renaming file or folder : ReferenceError: Buffer is not defined

  */
  const renameHandler = async () => {
    try {
      const itemName = selectedRow?.name || selectedFolder?.name;
      if (!itemName) {
        showToast("No item selected for rename", "error");
        return;
      }
      const sourcePath =
        "/" + currentPath.join("/") + "/" + itemName;
      const fo = await Item.getItem(sourcePath, false);
      const isFile = !!fileExtension || (selectedRow && selectedRow.type !== "folder");
      const normalizedNewName = normalizeName(rename + fileExtension, isFile);
      // console.log("fo is ", fo);
      ;
      await fo.rename(normalizedNewName);
      showToast("File/Folder renamed successfully", "success");
      // Fetch fresh data after successful rename to ensure UI is in sync
      await fetchData(currentPath);
    } catch (error) {
      showToast("Failed to rename", "error");
      await fetchData(currentPath);
    }
  };

  const saveHandler = async () => {
    const currentName = selectedRow?.name || selectedFolder?.name || "";
    if (!currentName) return;

    const isFile = !!fileExtension || (selectedRow && selectedRow.type !== "folder");
    const newName = normalizeName(rename + fileExtension, isFile);
    const oldName = selectedRow.name;

    // No-op rename should not call SDK (prevents "Failed to rename" on unchanged value).
    if (!newName || newName === currentName) {
      return;
    }

    // Temporarily update UI for immediate feedback
    setFilesData((prevFiles) =>
      prevFiles.map((file) =>
        file.name === oldName
          ? { ...file, name: newName }
          : file
      )
    );

    // Update checkedRows if the renamed item was selected
    setCheckedRows((prev) => {
      if (prev[oldName]) {
        const updated = { ...prev };
        const uuid = updated[oldName];
        delete updated[oldName];
        updated[newName] = uuid;
        return updated;
      }
      return prev;
    });

    // Await rename operation to complete
    await renameHandler();

    setRename("");
    setFileExtension("");
    setMenu({
      selectedRow: null,
      selectedOption: ""
    });
  };

  const cancelHandler = () => {
    // setRename("");
    // setFileExtension("");
    setMenu({
      selectedRow: null,
      selectedOption: ""
    });
  };

  const [dragging, setDragging] = useState(false);

  // Handle file drop
  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);

    const droppedFiles = Array.from(event.dataTransfer.files);

    if (droppedFiles.length > 0) {
      setSelectedFile((prevFiles) => [...prevFiles, ...droppedFiles]); // Append new files
      setFilesList((prevFiles) => [...prevFiles, ...droppedFiles]);
      setModal(true);
    }
  };

  // Drag over handlers
  const handleDragOver = (event) => {
    event.preventDefault();
    setDragging(true);
  };

  const handleDragEnter = () => setDragging(true);
  const handleDragLeave = () => setDragging(false);

  // useEffect(() => {
  // const fileName = selectedRow.name;
  // const downloadData = async () => {
  //   if (menu.selectedOption === "Download") {
  //     try {
  //       await init();
  //       const wasmInstance = new IzWasm(URL); // IzWasm Instance
  //       const chunkSize = 8 * 1024 * 1024; //
  //       const formattedPath =
  //         currentPath?.length === 0 ? "/" : `/${currentPath?.join("/")}`;
  //       const org = await wasmInstance.get_buffer(
  //         localStorage.getItem("mail"),
  //         `${formattedPath}/${fileName}`,
  //         [],
  //         BigInt(0),
  //         BigInt(18 * chunkSize)
  //       );
  //       // (bucket_name, file_name, buffer, offset, length) where file is backend.go
  //       console.log("org", org);
  //     } catch (error) {
  //       console.error("Failed to get buffer:", error);
  //     }
  //   }
  // };
  // downloadData();
  // }, [menu.selectedOption]);
  const moveToTrash = async () => {
    const itemName = selectedRow?.name;
    const fileName = "/" + currentPath.join("/") + "/" + selectedRow?.name;
    setMenu({ selectedRow: null, selectedOption: null });

    const deleteTask = new Task(0, `Deleting ${itemName}`, "Deleting");
    taskManager.addRunningTask(deleteTask);
    setTaskMonitorVisible(true);

    try {
      const fo = await Item.getItem(fileName, false);
      await fo.remove(false);

      if (deleteTask.status === 3) {
        taskManager.addCompletedTask(deleteTask, 3);
      } else {
        // Mark task as completed
        deleteTask.progress = 100;
        taskManager.addCompletedTask(deleteTask, 1);
      }

      showToast("File/Folder moved to trash", "success");
      fetchData(currentPath);
      // Dispatch event to update storage in real-time
      window.dispatchEvent(new CustomEvent("storageUpdated"));
    } catch (error) {
      // Mark task as failed
      deleteTask.progress = 0;
      taskManager.addCompletedTask(deleteTask, 2);
      showToast("Move to Trash failed", "error");
      console.error("Failed to remove object:", error);
    }
  };

  const onAllSelectRemove = async () => {
    const folderPathArr = [];
    const fileName = currentPath.join("/");
    const keys = Object.keys(checkedRows);

    for (const key of keys) {
      if (key) {
        // Construct full path to each selected file/folder
        folderPathArr.push(
          (fileName.length === 0 ? "" : "/") + fileName + "/" + key
        );
      }
    }

    if (folderPathArr.length === 0) return;

    const masterTask = new Task(keys.length, `Deleting ${keys.length} item(s)`, "Deleting");
    taskManager.addRunningTask(masterTask);
    setTaskMonitorVisible(true);

    let successfulCount = 0;
    let cancelled = false;
    try {
      for (let i = 0; i < folderPathArr.length; i++) {
        if (masterTask.getStatus() === 3) {
          cancelled = true;
          break;
        }
        const path = folderPathArr[i];
        const item = await Item.getItem(path, false);
        await item.remove();
        successfulCount++;
        masterTask.progress = Math.min(((i + 1) / keys.length) * 100, 99);
      }

      if (cancelled) {
        masterTask.name = `Cancelled — ${successfulCount} of ${keys.length} item(s) moved to trash`;
        taskManager.addCompletedTask(masterTask, 3);
        showToast("Move to Trash cancelled", "success");
      } else {
        masterTask.progress = 100;
        masterTask.name = `Deleting ${successfulCount} item(s)`;
        taskManager.addCompletedTask(masterTask, 1);
        showToast("Selected files/folders moved to trash", "success");
      }
      await fetchData(currentPath); // Refresh UI
      // Dispatch event to update storage in real-time
      window.dispatchEvent(new CustomEvent("storageUpdated"));
      setCheckedRows({});
      setIsAllChecked(false);
      setMenu({ selectedRow: null, selectedOption: null });
    } catch (error) {
      if (keys.length > 1) {
        const failed = keys.length - successfulCount;
        masterTask.name = `Deleting ${successfulCount} item(s), ${failed} failed`;
      }
      masterTask.progress = 0;
      taskManager.addCompletedTask(masterTask, 2);
      showToast("Move to Trash failed: " + error, "error");
      console.error("Move to Trash failed", error);
      setMenu({ selectedRow: null, selectedOption: null });
    }
  };
  // Process folder items page-by-page to avoid fetching all pages at once
  // (fetching all pages at once triggers browser security throttling)
  const forEachFolderItem = async (folder, dupCurrentPath, callback, onListed = null, shouldStop = null) => {
    let firstPage;
    if (dupCurrentPath[0] === "shared") {
      firstPage = await folder.getSharedWithMeFolderList(false);
    } else {
      firstPage = await folder.getFolderList();
    }
    if (onListed) onListed(folder);
    console.log("dupcurrnepath", dupCurrentPath);
    // Proactively list subfolders on this page to learn their counts early
    if (onListed) {
      const subfolders = firstPage.filter(item => item instanceof IzFolder);
      await Promise.all(subfolders.map(async (sf) => {
        try {
          if (dupCurrentPath[0] === "shared") {
            sf.getSharedWithMeFolderList(false);
          } else {
            sf.getFolderList();
          }
          await sf.getFolderList();
          onListed(sf);
        } catch (e) { /* ignore */ }
      }));
    }

    for (const item of firstPage) {
      if (shouldStop?.()) return;
      await callback(item);
    }
    if (!folder.getTotalItems || !folder.getPageSize || !folder.getNextFolderList) return;
    const total = folder.getTotalItems();
    const pageSize = folder.getPageSize();
    if (!total || total <= pageSize) return;
    const totalPages = Math.ceil(total / pageSize);
    for (let page = 1; page < totalPages; page++) {
      if (shouldStop?.()) return;
      try {
        const pageItems = await folder.getNextFolderList(page);
        if (pageItems && pageItems.length > 0) {
          // Proactively list subfolders on subsequent pages too
          if (onListed) {
            const subfolders = pageItems.filter(item => item instanceof IzFolder);
            await Promise.all(subfolders.map(async (sf) => {
              try { await sf.getFolderList(); onListed(sf); } catch (e) { /* ignore */ }
            }));
          }
          for (const item of pageItems) {
            if (shouldStop?.()) return;
            await callback(item);
          }
        }
      } catch (err) {
        console.error(`Failed to fetch folder page ${page + 1}:`, err);
      }
    }
  };

  // Download folder contents — uses native FS API (dirHandle) when available,
  // otherwise downloads each file individually as a blob
  const downloadIzFolder = async (folder, parentDirHandle, dupCurrentPath, masterTask, overrideName) => {
    const folderName = overrideName || folder.getFolderName();
    if (!folderName || folderName === "/") {
      throw new Error("Invalid folder name");
    }

    // If we have a native FS handle, create subdirectory and stream files into it
    const folderHandle = parentDirHandle
      ? await parentDirHandle.getDirectoryHandle(folderName, { create: true })
      : null;

    if (!masterTask._countedPaths) masterTask._countedPaths = new Set();

    await forEachFolderItem(folder, dupCurrentPath, async (item) => {
      if (masterTask.status === 3) return;
      if (item instanceof IzFile) {
        await downloadIzFile(item, item.getName(), folderHandle, dupCurrentPath, { masterTask, useBlobFallback: !folderHandle });
        if (masterTask.status === 3) return;
        masterTask.fileCount = (masterTask.fileCount || 0) + 1;
        if (masterTask.totalFileCount > 0) {
          masterTask.progress = Math.min(Math.floor((masterTask.fileCount / masterTask.totalFileCount) * 100), 99);
        }
        masterTask.taskDescription = `Downloaded ${masterTask.fileCount}/${masterTask.totalFileCount || "?"} files`;
      } else if (item instanceof IzFolder) {
        await downloadIzFolder(item, folderHandle, dupCurrentPath, masterTask);
      }
    }, (f) => {
      const key = (f.getParentPath?.() || "") + "/" + (f.getFolderName?.() || "");
      if (!masterTask._countedPaths.has(key)) {
        masterTask._countedPaths.add(key);
        masterTask.totalFileCount = (masterTask.totalFileCount || 0) + (f.getTotalItems() || 0);
      }
    }, () => masterTask.status === 3);
  };

const downloadIzFile = async (fo, fileName, dirHandle, dupCurrentPath, { masterTask = null, useBlobFallback = false } = {}) => {
  const totSize = fo.getSize();

  let displayFileName;
  if (dupCurrentPath.length === 1 && dupCurrentPath[0] === "shared") {
    displayFileName = fo.getName();
  } else {
    displayFileName = fileName;
  }

  const dataTask = masterTask
    ? new Task(totSize, displayFileName, "Downloading")
    : new Task(totSize, `Downloading ${displayFileName}`, "Downloading");

  if (!masterTask) {
    taskManager.addRunningTask(dataTask);
  }

  try {
    const chunks = [];
    let writer;
    let fileStream;
    let useNativeFS = false;

    let currentFileName;
    if (dupCurrentPath.length === 1 && dupCurrentPath[0] === "shared") {
      currentFileName = fo.getName();
    } else {
      currentFileName = fileName;
    }

    // Mode 1: dirHandle provided — write file into a directory (folder download with native FS)
    if (dirHandle) {
      useNativeFS = true;
      const fileHandle = await dirHandle.getFileHandle(currentFileName, { create: true });
      fileStream = await fileHandle.createWritable();
      writer = fileStream;
    }
    // Mode 2: File System Access API — individual file save picker (skip if useBlobFallback)
    else if (window.showSaveFilePicker && !useBlobFallback) {
      useNativeFS = true;
      const handle = await window.showSaveFilePicker({
        suggestedName: currentFileName,
      });
      fileStream = await handle.createWritable();
      writer = fileStream;
    }
    // Mode 3: Blob fallback — accumulate chunks in memory
    else {
      writer = {
        write(chunk) {
          chunks.push(chunk);
        },
      };
    }

    const maxConcurrency = 12;
    const chunkSize = 4 * 1024 * 1024;
    const totalChunks = Math.ceil(totSize / chunkSize);
    let errorOccurred = null;

    let path = fo.getParentPath() + "/" + fo.getName();
    if (dupCurrentPath.length === 1 && dupCurrentPath[0] === "shared") {
      path = fo.getParentPath() + "/" + fileName;
    }

    const downloadChunk = async (start) => {
      if (errorOccurred) return;
      const remainingChunkSize = Math.min(chunkSize, totSize - start);
      for (let attempt = 0; attempt <= MAX_CHUNK_RETRIES; attempt++) {
        try {
          const data = await withTimeout(
            fo.getChunk(start, path, dataTask, remainingChunkSize),
            CHUNK_TIMEOUT,
            `Download chunk at offset ${start}`
          );
          if (useNativeFS) {
            await writer.write({ type: "write", position: start, data });
          } else {
            chunks[start] = data;
          }
          return;
        } catch (err) {
          if (attempt < MAX_CHUNK_RETRIES) {
            const delay = Math.min(1000 * Math.pow(2, attempt), 8000);
            await new Promise((r) => setTimeout(r, delay));
            continue;
          }
          errorOccurred = err;
          throw err;
        }
      }
    };

    // Build all offsets upfront
    const offsets = [];
    for (let i = 0; i < totalChunks; i++) {
      offsets.push(i * chunkSize);
    }

    // Process in strict batches of maxConcurrency
    for (let i = 0; i < offsets.length; i += maxConcurrency) {
      if (errorOccurred || dataTask.status === 3) break;

      const batch = offsets.slice(i, i + maxConcurrency);

      await Promise.all(
        batch.map((start) => downloadChunk(start))
      );

      if (errorOccurred) throw errorOccurred;
    }

    // Finalize file
    if (useNativeFS) {
      await fileStream.close();
    } else {
      const orderedChunks = [];
      const positions = Object.keys(chunks).map(Number).sort((a, b) => a - b);
      for (const position of positions) {
        orderedChunks.push(chunks[position]);
      }

      const blob = new Blob(orderedChunks);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = currentFileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    }

    if (!masterTask) taskManager.addCompletedTask(dataTask, 1);
  } catch (error) {
    if (error.name === "AbortError") {
      if (!masterTask) taskManager.addCompletedTask(dataTask, 3);
      return;
    }
    if (!masterTask) {
      if (dataTask.status === 3) {
        taskManager.addCompletedTask(dataTask, 3);
      } else {
        taskManager.addCompletedTask(dataTask, 2);
      }
    }
    throw error;
  }
};

  const downloadFile = async () => {
    // console.log("download file is clicked");
    setTaskMonitorVisible(true);
    window.dispatchEvent(new CustomEvent("operationStart"));
    try {
      let fileName = selectedRow.name;
      let dupCurrentPath = currentPath;
      if (dupCurrentPath[0] === "shared" && dupCurrentPath.length >= 2) {
        const newPath = [...dupCurrentPath];
        newPath.splice(1, 1);
        dupCurrentPath = newPath;
      }
      if (dupCurrentPath.length === 1 && dupCurrentPath[0] == "shared") {
        fileName = selectedRow.uuids;
      }
      const formattedPath =
        dupCurrentPath?.length === 0 ? "" : `/${dupCurrentPath?.join("/")}`;
      const fo = await Item.getItem(formattedPath + "/" + fileName);
      if (fo instanceof IzFile) {
        await downloadIzFile(fo, fileName, undefined, dupCurrentPath);
        showToast("File downloaded successfully", "success");
      } else if (fo instanceof IzFolder) {

        const folderName = fo.getFolderName() || selectedRow.name;

        // Use native FS directory picker if available, otherwise download files individually
        let parentDirHandle = null;
        if (window.showDirectoryPicker) {
          try {
            parentDirHandle = await window.showDirectoryPicker();
          } catch (error) {
            if (error.name === "AbortError") return; // User cancelled picker
            throw error;
          }
        }
        if (dupCurrentPath.length === 1 && dupCurrentPath[0] == "shared") {
          fo.setFolderName(fo.getUuId());
        }
        const masterTask = new Task(0, `Downloading ${folderName}`, "Downloading");
        masterTask.fileCount = 0;
        masterTask.totalFileCount = 0;
        taskManager.addRunningTask(masterTask);
        try {
          await downloadIzFolder(fo, parentDirHandle, dupCurrentPath, masterTask, folderName);
          if (masterTask.status === 3) {
            masterTask.name = `Cancelled — Downloaded ${masterTask.fileCount || 0} files`;
            taskManager.addCompletedTask(masterTask, 3);
          } else {
            masterTask.progress = 100;
            taskManager.addCompletedTask(masterTask, 1);
            showToast("Folder downloaded successfully", "success");
          }
        } catch (error) {
          taskManager.addCompletedTask(masterTask, 2);
          throw error;
        }
      }
    } catch (error) {
      showToast(`Download failed:${error}`, "error");
      console.error("Failed to get buffer: here !!", error);
    } finally {
      window.dispatchEvent(new CustomEvent("operationEnd"));
    }
  };
  const handleRestoreFromTrash = async () => {
    const itemName = selectedRow?.name;
    setMenu({ selectedRow: null, selectedOption: null });

    const restoreTask = new Task(0, `Restoring ${itemName}`, "Restoring");
    taskManager.addRunningTask(restoreTask);
    setTaskMonitorVisible(true);

    try {
      const sourcePath = "/" + itemName;
      const fo = await Item.getItem(sourcePath, true);
      await fo.restore();

      if (restoreTask.status === 3) {
        taskManager.addCompletedTask(restoreTask, 3);
      } else {
        restoreTask.progress = 100;
        taskManager.addCompletedTask(restoreTask, 1);
      }

      showToast("File/Folder restored successfully", "success");
      fetchData(currentPath);
      // Dispatch event to update storage in real-time
      window.dispatchEvent(new CustomEvent("storageUpdated"));
    } catch (error) {
      restoreTask.progress = 0;
      taskManager.addCompletedTask(restoreTask, 2);
      showToast(`Restore failed:${error}`, "error");
      console.error("Failed to restore object:", error);
    }
  };

  const handleMultiSelectedRestore = async () => {
    const restorePaths = [];
    const errors = [];

    // Assuming checkedRows contains names of files/folders to restore
    for (const key in checkedRows) {
      if (key) {
        // Many trash items are accessed by prefixing the name with a slash
        restorePaths.push("/" + key);
      }
    }

    setCheckedRows({});
    setIsAllChecked(false);
    setSelectedModal(null);

    if (restorePaths.length === 0) return;

    const masterTask = new Task(restorePaths.length, `Restoring ${restorePaths.length} item(s)`, "Restoring");
    taskManager.addRunningTask(masterTask);
    setTaskMonitorVisible(true);

    let successfulCount = 0;
    let cancelled = false;

    // Restore each item individually and track errors
    for (let i = 0; i < restorePaths.length; i++) {
      if (masterTask.getStatus() === 3) {
        cancelled = true;
        break;
      }
      const path = restorePaths[i];
      try {
        const item = await Item.getItem(path, true); // `true` to indicate it's in trash
        await item.restore();
        successfulCount++;
        masterTask.progress = Math.min(((i + 1) / restorePaths.length) * 100, 99);
      } catch (error) {
        console.error(`Failed to restore ${path}:`, error);
        errors.push(path);
      }
    }

    if (cancelled) {
      masterTask.name = `Cancelled — ${successfulCount} of ${restorePaths.length} items restored`;
      taskManager.addCompletedTask(masterTask, 3);
      showToast("Restore cancelled", "success");
    } else {
      if (errors.length > 0 && errors.length < restorePaths.length) {
        masterTask.name = `Restoring ${successfulCount} item(s), ${errors.length} failed`;
      } else {
        masterTask.name = `Restoring ${successfulCount} item(s)`;
      }

      // Show appropriate message based on results
      if (errors.length === 0) {
        masterTask.progress = 100;
        taskManager.addCompletedTask(masterTask, 1);
        showToast("Selected items restored successfully", "success");
      } else if (errors.length < restorePaths.length) {
        masterTask.progress = 100;
        taskManager.addCompletedTask(masterTask, 2);
        showToast(`${restorePaths.length - errors.length} items restored successfully. ${errors.length} failed.`, "warning");
      } else {
        masterTask.progress = 0;
        taskManager.addCompletedTask(masterTask, 2);
        showToast("Error restoring selected items from trash", "error");
      }
    }

    fetchData(currentPath); // Refresh UI
    // Dispatch event to update storage in real-time
    window.dispatchEvent(new CustomEvent("storageUpdated"));
  };

  const removeSelectedFromTrash = async () => {
    const folderPathArr = [];
    const fileName = currentPath.join("/");
    const keys = Object.keys(checkedRows);

    for (const key of keys) {
      if (key) {
        // making the array with desired path
        folderPathArr.push(
          (fileName.length === 0 ? "" : "/") + fileName + "/" + key
        );
      }
    }

    if (folderPathArr.length === 0) return;

    const masterTask = new Task(keys.length, `Deleting ${keys.length} item(s)`, "Deleting");
    taskManager.addRunningTask(masterTask);
    setTaskMonitorVisible(true);

    let successfulCount = 0;
    let cancelled = false;
    try {
      for (let i = 0; i < folderPathArr.length; i++) {
        if (masterTask.getStatus() === 3) {
          cancelled = true;
          break;
        }
        const path = folderPathArr[i];
        const item = await Item.getItem(path, true);
        await item.remove(true); // Permanently delete
        successfulCount++;
        masterTask.progress = Math.min(((i + 1) / keys.length) * 100, 99);
      }

      if (cancelled) {
        masterTask.name = `Cancelled — ${successfulCount} of ${keys.length} deleted`;
        taskManager.addCompletedTask(masterTask, 3);
        showToast("Delete permanently cancelled", "success");
      } else {
        masterTask.progress = 100;
        masterTask.name = `Deleting ${successfulCount} item(s)`;
        taskManager.addCompletedTask(masterTask, 1);
        showToast("Selected items permanently deleted", "success");
      }
      await fetchData(currentPath);
      // Dispatch event to update storage in real-time
      window.dispatchEvent(new CustomEvent("storageUpdated"));
      setCheckedRows({});
      setIsAllChecked(false);
      setMenu({ selectedRow: null, selectedOption: null });
    } catch (error) {
      if (keys.length > 1) {
        const failed = keys.length - successfulCount;
        masterTask.name = `Deleting ${successfulCount} item(s), ${failed} failed`;
      }
      masterTask.progress = 0;
      taskManager.addCompletedTask(masterTask, 2);
      showToast("Error removing selected items from trash : " + error, "error");

      setMenu({ selectedRow: null, selectedOption: null });
    }
  };

  const removeAllFromTrash = async () => {
    setMenu({ selectedRow: null, selectedOption: null });

    // 1. Initialize Master Task
    const rawTotal = (folder && typeof folder.getTotalItems === "function") ? folder.getTotalItems() : filesData.length;
    const totalItems = Number(rawTotal) || 0;
    const masterTask = new Task(totalItems, "Emptying Trash", "Deleting");
    taskManager.addRunningTask(masterTask);
    setTaskMonitorVisible(true);

    let processedCount = 0;
    let failedCount = 0;

    try {
      const allItems = [];
      const isFoldersArr = [];

      // Fetch ALL items from all pages if necessary
      let pageNum = 0;
      let shouldContinuePaging = true;
      const fileObject = new IzFile();

      while (shouldContinuePaging) {
        if (masterTask.getStatus() === 3) break;
        let pageItems = [];
        if (pageNum === 0) {
          pageItems = filesData;
        } else if (folder && typeof folder.getNextFolderList === "function") {
          pageItems = await folder.getNextFolderList(pageNum);
        }

        if (!pageItems || pageItems.length === 0) {
          shouldContinuePaging = false;
          break;
        }

        pageItems.forEach((file) => {
          if (file) {
            allItems.push(file.name || (file instanceof IzFolder ? file.getFolderName() : file.getName()));
            isFoldersArr.push(file.type === "folder" || file instanceof IzFolder);
          }
        });

        // Process in smaller batches (10) to ensure intermediate progress updates are visible
        // even for smaller trash folders, and to maintain UI responsiveness.
        while (allItems.length >= 10) {
          if (masterTask.getStatus() === 3) break;
          const itemsBatch = allItems.splice(0, 10);
          const foldersBatch = isFoldersArr.splice(0, 10);
          try {
            await fileObject.emptyTrash(itemsBatch, foldersBatch);
            processedCount += itemsBatch.length;
            // Add a tiny delay between batches so the UI has time to render the progress
            await new Promise((resolve) => setTimeout(resolve, 100));
          } catch (err) {
            console.error("Batch deletion failed", err);
            failedCount += itemsBatch.length;
          }
          masterTask.progress = totalItems > 0 ? Math.min(Math.floor((processedCount / totalItems) * 100), 99) : 0;
        }

        // Check for cancellation after finishing the batches for this page
        if (masterTask.getStatus() === 3) {
          console.log("Empty Trash: Outer loop detected cancelation, breaking.");
          shouldContinuePaging = false;
          break;
        }

        pageNum++;
        if (folder && typeof folder.getTotalItems === "function" && typeof folder.getPageSize === "function") {
          if (folder.getTotalItems() <= pageNum * folder.getPageSize()) {
            shouldContinuePaging = false;
          }
        } else {
          shouldContinuePaging = false;
        }
      }

      // Process remaining items (if fewer than 10 total or remaining)
      if (allItems.length > 0 && masterTask.getStatus() !== 3) {
        try {
          await fileObject.emptyTrash(allItems, isFoldersArr);
          processedCount += allItems.length;
          await new Promise((resolve) => setTimeout(resolve, 100));
        } catch (err) {
          console.error("Final batch deletion failed", err);
          failedCount += allItems.length;
        }
        masterTask.progress = totalItems > 0 ? Math.min(Math.floor((processedCount / totalItems) * 100), 99) : 0;
      }

      // 4. Mark Task Status
      if (masterTask.getStatus() === 3) {
        masterTask.name = `Cancelled — ${processedCount} of ${totalItems} deleted from trash`;
        taskManager.addCompletedTask(masterTask, 3);
        showToast("Empty Trash cancelled", "success");
      } else {
        masterTask.progress = 100;
        taskManager.addCompletedTask(masterTask, failedCount > 0 ? 2 : 1);

        if (failedCount === 0) {
          showToast("Trash emptied successfully", "success");
        } else {
          showToast(`${failedCount} items could not be deleted permanently`, "warning");
        }
      }

      fetchData(currentPath);
      window.dispatchEvent(new CustomEvent("storageUpdated"));
    } catch (error) {
      console.error("Error emptying trash:", error);
      masterTask.progress = 0;
      taskManager.addCompletedTask(masterTask, 3);
      showToast("Error removing all items from trash: " + (error?.message || error), "error");
    }
  };
  const handleRemoveFromTrash = async () => {
    const itemName = selectedRow?.name;
    const fileName = selectedRow?.name;
    setMenu({ selectedRow: null, selectedOption: null });
    const deleteTask = new Task(0, `Deleting ${itemName}`, "Deleting");
    taskManager.addRunningTask(deleteTask);
    setTaskMonitorVisible(true);

    try {
      const fo = await Item.getItem(fileName, true);
      await fo.remove(true);

      if (deleteTask.status === 3) {
        taskManager.addCompletedTask(deleteTask, 3);
      } else {
        // Mark task as completed
        deleteTask.progress = 100;
        taskManager.addCompletedTask(deleteTask, 1);
      }

      showToast("File permanently deleted", "success");
      fetchData(currentPath);
      // Dispatch event to update storage in real-time
      window.dispatchEvent(new CustomEvent("storageUpdated"));
    } catch (error) {
      // Mark task as failed
      deleteTask.progress = 0;
      taskManager.addCompletedTask(deleteTask, 2);
      showToast(`Remove failed:${error}`, "error");
      console.error("Failed to remove from trash object:", error);
    }
  };
  const [clickTimeout, setClickTimeout] = useState(true); // Declare

  const handleRowClick = (row, idx) => {
    if (clickTimeout) {
      clearTimeout(clickTimeout);
      setClickTimeout(null);

      if (row?.original?.type === "folder") {
        // Prevent double-click navigation for folders in trash
        if (activeTab + 1 === 3) {
          return;
        }
        if (currentPath.length == 2 && activeTab + 1 == 2) {
          // Shared tab: navigate by UUID, show folder name in breadcrumb
          handleFolderClick(filesData[idx]?.uuids || row.original.name);
          setSelectedFolder(filesData[idx]?.uuids || row.original.name);
          handledupFolderClick(row.original.name);
        } else {
          handleFolderClick(row.original.name);
          setSelectedFolder(row.original.name);
          handledupFolderClick(row.original.name);
        }
      }
    } else {
      setClickTimeout(
        setTimeout(() => {
          setClickTimeout(null);
        }, 300) // Adjust timing if needed
      );
    }
  };


  const truncateName = (name) => {

    if (!name) return "";

    return name.length > 20 ? `${name.slice(0, 5)}....` : name;

  };
  const loadCollobora = (selRow) => {
    const idx = selRow.uuids;
    // console.log("selected row is ", selRow, idx);
    const parentPath = currentPath.join("/");
    let filePath = [parentPath, selRow.name]
      .filter(Boolean) // remove empty parts
      .join("/");
    // console.log("active tab is ", filePath);
    if (activeTab === 1) {
      const temp = "shared/" + idx;
      filePath = temp;
    }
    // console.log("slash count is ", filePath);

    const data = {
      filePath: filePath,
      token: localStorage.getItem("izauthtoken"),
      shared: activeTab === 1,
      pin: getPin(),
      email: getEmail()
    };
    const base64Data = btoa(JSON.stringify(data));
    const fileIdEnc = encodeURIComponent(selRow?.uuids);
    const wopiSrc = `${WOPI_URL}/wopi/files/${fileIdEnc}`;
    collaboraURL.current = `${COLLABORA_URL}/browser/dist/cool.html?WOPISrc=${encodeURIComponent(wopiSrc)}&access_token=${base64Data}`;
    setShowCollabora(true);
  };

  return (
    <div className="tabsTableWrapper">
      {/* {!searchQuery && (
        <Tabs
          tabsTitles={tabsTitles}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          TabIcons={TabIcons}
          tabIconKeys={tabIconKeys}
          marginBottom="0px"
        />
      )} */}
      {activeTab + 1 !== 4 && (
        <BreadCrumb currentPath={currentPath} setCurrentPath={setCurrentPath} dupCurrentPath={dupCurrentPath} activeTab={activeTab} setdupCurrentPath={setdupCurrentPath} />
      )}

      {count > 0 && !isMobile && (
        <div className="actionsIconBox">
          <div className="left">
            <div className="actionsIconBoxCount">{count} items Selected</div>
            <div className="actionsIconBoxWrapper">
              {(() => {
                // Action permission mapping for bulk actions
                const PERMISSIONS = {
                  moveTo: 3,
                  copy: 2,
                  favorite: 37,
                  download: 6,
                  share: 5,
                  restore: 14,
                  delete: 15
                };

                return actionIconTitles.map((title, index) => {
                  const isTrash = tabsTitles[activeTab] === "Trash";
                  const isSharedWithMe = tabsTitles[activeTab] === "Shared with me";

                  if (!showSharedTab && title === "share") {
                    return null;
                  }

                  const showIcon = isTrash
                    ? (index === 5 || index === 6)
                    : isSharedWithMe
                      ? index === 1
                      : index <= 1 || index === 6;

                  if (showIcon) {
                    const opId = title === "delete" ? (isTrash ? 15 : 4) : PERMISSIONS[title];
                    if (opId && isOrganisationUser && hasBackendOperationData) {
                      const email = getEmail() || sessionStorage.getItem("mail");
                      const allOwned = Object.keys(checkedRows).every(name => {
                        const file = filesData.find(f => f.name === name);
                        return file?.owner === "you" || (email && file?.owner === email);
                      });

                      // If not all items are owned, check for explicit backend operation permission
                      if (!allOwned && !hasBackendOperationPermission(opId)) {
                        return null;
                      }
                    }

                    return (
                      <div
                        className="iconBox"
                        key={index}
                        onClick={() => setSelectedModal(title)}
                        style={{ cursor: "pointer" }}
                      >
                        <GetActionIcon
                          type={title}
                          color="var(--text-grey-strong)"
                        />
                      </div>
                    );
                  }
                  return null;
                });
              })()}
              {/* here is the share */}
            </div>
          </div>
          <div
            className="right"
            onClick={() => {
              setIsAllChecked(false);
              setCheckedRows({});
            }}
            style={{ cursor: "pointer" }}
          >
            <GetActionIcon type="cross" color="var(--text-grey-strong)" />
          </div>
        </div>
      )}
      {/* Modals rendered outside !isMobile guard so they work for both desktop and mobile */}
      {count > 0 && (
        <>
          {selectedModal === "share" ? (
            <ShareFiles
              handleCancel={() => setSelectedModal(null)}
              sharedData={filteredFilesData}
              checkedRows={checkedRows}
            />
          ) : selectedModal === "delete" ? (
            <DeleteModal
              key={filteredFilesData}
              headerTitle={activeTab + 1 === 3 ? "Delete" : "Move to Trash"}
              content={activeTab + 1 === 3
                ? `Are you sure you want to delete ${count} item${count === 1 ? "" : "s"} permanently?`
                : `Are you sure you want to move ${count} item${count === 1 ? "" : "s"} to the trash?`
              }
              handleCancel={() => setSelectedModal(null)}
              handleSave={() => {
                if (activeTab + 1 === 3) {
                  removeSelectedFromTrash();
                  setSelectedModal(null);
                } else {
                  onAllSelectRemove();
                  setSelectedModal(null);
                }
              }}
              selectedModal={selectedModal}
            />
          ) : selectedModal === "copy" ? (
            <MoveFile
              copied={true}
              handleCancel={() => {
                setSelectedModal(null);
                setCheckedRows({});
                setIsAllChecked(false);
              }}
              rowData={selectedRow}
              movedData={filteredFilesData}
              selectedModal={selectedModal}
              currentPath={currentPath}
              UUIDArrays={UUIDArrays}
              fetchData={fetchData}
              setCurrentPath={setCurrentPath}
              selectedFolder={selectedFolder}
              checkedRows={checkedRows}
              count={count}
              taskManager={taskManager}
              setTaskMonitorVisible={setTaskMonitorVisible}
              isOrganisationUser={isOrganisationUser}
              backendOperations={backendOperations}
              clearSelections={() => {
                setCheckedRows({});
                setIsAllChecked(false);
              }}
            />
          ) : selectedModal === "moveTo" ? (
            <MoveFile
              copied={false}
              handleCancel={() => {
                setSelectedModal(null);
                setCheckedRows({});
                setIsAllChecked(false);
              }}
              rowData={selectedRow}
              movedData={filteredFilesData}
              selectedModal={selectedModal}
              currentPath={currentPath}
              fetchData={fetchData}
              setCurrentPath={setCurrentPath}
              selectedFolder={selectedFolder}
              checkedRows={checkedRows}
              count={count}
              taskManager={taskManager}
              setTaskMonitorVisible={setTaskMonitorVisible}
              isOrganisationUser={isOrganisationUser}
              backendOperations={backendOperations}
              clearSelections={() => {
                setCheckedRows({});
                setIsAllChecked(false);
              }}
            />
          ) : selectedModal === "restore" ? (
            <RestoreModal
              handleSave={handleMultiSelectedRestore}
              handleCancel={() => setSelectedModal(null)}
              content={`Are you sure you want to restore ${Object.keys(checkedRows).length === 1
                ? "this item"
                : `these ${Object.keys(checkedRows).length} items`
                }?`}
            />
          ) : null}
        </>
      )}
      {/* {searchQuery && (
        <h3 className="searchCount">Search Result ({filesData.length})</h3>
      )} */}
      {/* Select All for Grid View */}
      {/* Grid mode disabled for trash */}
      {layout === "grid" && filesData.length > 0 && !isMobile && activeTab + 1 !== 3 && !isSharedWithMeRoot && (
        <div className="gridSelectAllWrapper">
          <SquareCheckBox
            label="Select All"
            isChecked={isAllChecked}
            isDisable={false}
            onChange={handleSelectAll}
          />
        </div>
      )}
      {/* rename is here */}
      {menu.selectedOption === "Rename" && (
        <RenameFile
          heading="Rename"
          placeholder="Rename the file/folder"
          setMenu={setMenu}
          menu={menu}
          inputWidth="93%"
          handleCancel={cancelHandler}
          handleSave={saveHandler}
          value={rename}
          onChange={changeHandler}
          rowData={selectedRow}
          wrapWidth="100%"
          disabled={
            rename.trim().length === 0 ||
            normalizeName(
              rename + fileExtension,
              !!fileExtension || (selectedRow && selectedRow.type !== "folder")
            ) === (selectedRow?.name || "")
          }
        />
      )}
      {menu.selectedOption === "Trash" && (
        <DeleteModal
          headerTitle="Move to Trash"
          content={`Are you sure you want to move “${truncateName(selectedRow.name)}” to trash?`}
          handleCancel={handleMenu}
          handleSave={moveToTrash}
        />
      )}
      {(menu.selectedOption === "Move to" ||
        menu.selectedOption === "Copy to") && (
          <MoveFile
            copied={
              menu.selectedOption === "Move to"
                ? false
                : menu.selectedOption === "Copy to"
                  ? true
                  : ""
            }
            handleCancel={handleMenu}
            rowData={selectedRow}
            UUIDArrays={UUIDArrays}
            currentPath={currentPath}
            fetchData={fetchData}
            setCurrentPath={setCurrentPath}
            selectedFolder={selectedFolder}
            taskManager={taskManager}
            setTaskMonitorVisible={setTaskMonitorVisible}
            isOrganisationUser={isOrganisationUser}
            backendOperations={backendOperations}
          />
        )}
      {menu.selectedOption === "Add to Space" && (
        <ExternalSpaceModal
          placeHolder=""
          setMenu={setMenu}
          menu={menu}
          handleCancel={handleMenu}
          title={truncateName(selectedRow?.name)}
          selectedFolder={selectedFolder}
          currentPath={currentPath}
        />
      )}
      {menu.selectedOption === "Share" && (
        <ShareProject
          placeHolder=""
          setMenu={setMenu}
          menu={menu}
          handleCancel={handleMenu}
          title={truncateName(selectedRow?.name)}
          selectedFolder={selectedFolder || selectedRow}
          selectedRow={selectedRow}
          currentPath={currentPath}
        />
      )}

      {menu.selectedOption === "Details" && (
        <Files
          handleCancel={handleMenu}
          setMenu={setMenu}
          menu={menu}
          isVisible={true}
          title={selectedRow?.name}
          selectedRow={selectedRow}
          currentPath={currentPath}
        />
      )}

      {menu.selectedOption === "Versions" && (
        <VersionHistory
          handleCancel={handleMenu}
          setMenu={setMenu}
          menu={menu}
          isVisible={true}
          selectedRow={selectedRow}
          currentPath={currentPath}
        />
      )}

      {menu.selectedOption === "Restore" && (
        <RestoreModal
          handleCancel={handleMenu}
          content={`Are you sure you want to restore "${truncateName(selectedRow?.name)}"?`}
          handleSave={handleRestoreFromTrash}
        />
      )}

      {menu.selectedOption === "Delete forever" && (
        <DeleteModal
          headerTitle="Delete forever"
          content={`Are you sure you want to delete "${selectedRow?.name}" permanently?`}
          handleCancel={handleMenu}
          handleSave={handleRemoveFromTrash}
        />
      )}
      {menu.selectedOption == "delete forever trash" && (
        <DeleteModal
          headerTitle="Empty Trash"
          content={"Are you sure you want to delete all the items permanently?"}
          handleCancel={handleMenu}
          handleSave={removeAllFromTrash}
        />
      )}

      {activeTab + 1 === 3 && filesData.length > 0 && (
        <div className="trashHeader">
          <p className="text" style={{ cursor: "pointer" }}>
            {trashRetentionBanner}
          </p>
          <p
            className="title"
            onClick={() => {
              setMenu((pre) => ({
                ...pre,
                selectedOption: "delete forever trash"
              }));
            }}
          >
            Empty Trash
          </p>
        </div>
      )}
      {filesData.length < 0 ? (
        <div
          className={`nofiles ${dragging ? "dragging" : ""}`}
          onDrop={handleDrop}
          style={{ height: "55vh" }}
          onDragOver={handleDragOver}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
        >
          <div className="addFiles">
            <img src={addFile} alt="add file" />
            <h3 className="title">No Data</h3>
            <p className="content">
              Use the Add button to add files or folders.
            </p>
          </div>
        </div>
      ) : (
        <div
          className="tableContainer"
          style={{
            backgroundColor:
              layout == "grid" && activeTab + 1 !== 3
                ? "transparent"
                : theme === "light"
                  ? "white"
                  : "#1C191E",
            paddingTop: "0px",
            overflow: "hidden",
            minHeight: isMobile
              ? "calc(100vh - 165px)"
              : layout === "grid" && activeTab + 1 !== 3
                ? (activeTab + 1 === 3 ? "calc(100vh - 344px)" : "calc(100vh - 280px)")
                : (activeTab + 1 === 3 ? "calc(100vh - 264px)" : "calc(100vh - 200px)"),
            maxHeight: isMobile
              ? "calc(100vh - 165px)"
              : layout === "grid" && activeTab + 1 !== 3
                ? (activeTab + 1 === 3 ? "calc(100vh - 344px)" : "calc(100vh - 280px)")
                : (activeTab + 1 === 3 ? "calc(100vh - 264px)" : "none"),
            overflowY: "auto",
            display: layout === "grid" && activeTab + 1 !== 3 ? "flex" : "block",
            flexDirection: layout === "grid" && activeTab + 1 !== 3 ? "column" : "unset",
          }}
        >
          <table
            className={`table ${layout === "grid" && activeTab + 1 !== 3 ? "gridTable" : ""}`}
            {...getTableProps()}
          >
            <thead
              className={`tableHead ${layout === "grid" && activeTab + 1 !== 3 ? "gridTableHead" : ""}`}
            >
              {isMobile ? (
                <tr className="mobile-header">
                  <th className="tableHeadRowHeaderBox" style={{ display: "flex", alignItems: "center", gap: "8px", paddingLeft: "8px" }}>
                    {!isSharedWithMeRoot && (
                      <SquareCheckBox
                        label=""
                        isChecked={isAllChecked}
                        isDisable={false}
                        onChange={handleSelectAll}
                      />
                    )}
                    <span>Name</span>
                  </th>
                </tr>
              ) : (
                headerGroups.map((headerGroup) => {
                  const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
                  return (
                    <tr
                      className="tableHeadRow"
                      key={key}
                      {...headerGroupProps}
                    >
                      {headerGroup.headers.map((column) => {
                        const { key, ...columnProps } = column.getHeaderProps();
                        return (
                          <th
                            className="tableHeadRowHeaderBox"
                            style={{
                              width: column.width,
                              maxWidth: column.width,
                              flex: `0 0 ${column.width}`,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap"
                            }}
                            key={key}
                            {...columnProps}
                          >
                            {column.render("Header")}
                          </th>
                        );
                      })}
                    </tr>
                  );
                })
              )}
            </thead>

            <tbody
              className={`tableBody ${layout === "grid" && activeTab + 1 !== 3 ? "gridTableBody" : ""}`}
              {...getTableBodyProps()}
              style={{
                backgroundColor:
                  layout === "grid" && activeTab + 1 !== 3
                    ? "transparent"
                    : theme === "light"
                      ? "white"
                      : "#1C191E",
                borderBottomLeftRadius: 8,
                borderBottomRightRadius: 8,
                ...(layout === "grid" && activeTab + 1 !== 3 && {
                  display: "grid",
                  gridTemplateColumns: isMobile
                    ? "1fr"
                    : "repeat(auto-fill, minmax(140px, 1fr))",
                  gap: "16px",
                  padding: "20px 16px",
                  flex: 1,
                  minHeight: 0,
                  overflowY: "auto",
                  overflowX: "hidden",
                }),
              }}
            >
              {rows.map((row, idx) => {
                prepareRow(row);
                const { key, ...rowProps } = row.getRowProps();
                return (
                  <tr
                    className={`tableBodyRow ${isMobile ? "tableBodyMobileRow" : ""
                      } ${layout === "grid" && activeTab + 1 !== 3 ? "gridTableBodyRow" : ""}`}
                    key={key}
                    {...rowProps}
                    onTouchStart={(e) =>
                      isMobile && (layout === "table" || (layout === "grid" && activeTab + 1 !== 3))
                        ? handleTouchStart(e, row.original.name, row.original.uuids)
                        : null
                    }
                    onTouchEnd={handleTouchEnd}
                    onTouchMove={handleTouchEnd}
                    style={{
                      backgroundColor: (row.original.name in checkedRows)
                        ? "var(--gray-gray-8)"
                        : undefined
                    }}
                    onClick={() => {
                      if (isMobile) {
                        handleMobileRowClick(row.original.name, row.original.uuids);
                      }
                    }}
                    onDoubleClick={async () => {
                      if (checkedRows && Object.keys(checkedRows).length != 0) {
                        return;
                      }
                      if (row?.original?.type === "folder") {
                        // Prevent double-click navigation for folders in trash
                        if (activeTab + 1 === 3) {
                          return;
                        }
                        if (currentPath.length == 2 && activeTab + 1 == 2) {
                          // currentPath.push("shared");
                          handleFolderClick(filesData[idx].uuids);
                          setSelectedFolder(filesData[idx].uuids);
                          handledupFolderClick(row.original.name);

                        }
                        else {
                          handleFolderClick(row.original.name);
                          setSelectedFolder(row.original.name);
                          handledupFolderClick(row.original.name);
                        }
                      }
                      else if (row?.original?.type === "file") {
                        const selRow = row?.original;
                        let fileName = selRow.name;
                        const fileExtension = selRow.name?.split(".").pop()?.toLowerCase();
                        try {
                          let dupCurrentPath = currentPath;
                          // let filePathName = fileName;
                          // console.log("current path before opening file", dupCurrentPath, fileName);
                          if (dupCurrentPath[0] === "shared" && dupCurrentPath.length >= 2) {
                            const newPath = [...dupCurrentPath];
                            newPath.splice(1, 1);
                            dupCurrentPath = newPath;
                          }
                          let fileNameForShared = fileName;
                          if (dupCurrentPath.length === 1 && (dupCurrentPath[0] == "shared" || dupCurrentPath[0] === "external_shared")) {
                            fileName = selRow.uuids;
                            fileNameForShared = fileName;
                          }
                          console.log("final path and name for opening file", dupCurrentPath, fileName, fileExtension, fileNameForShared);
                          // Use the original name for file type detection
                          // console.log("formatted path before opening file", dupCurrentPath, fileName, fileExtension);
                          const formattedPath =
                            dupCurrentPath?.length === 0 ? "" : `/${dupCurrentPath?.join("/")}`;
                          const fo = await Item.getItem(formattedPath + "/" + fileName);

                          if (fo instanceof IzFile) {

                            // Get file type from SDK
                            const fileType = fo.getFileType();

                            // Check if file is PDF using file type from SDK
                            if (fileType === "application/pdf" || fileExtension === "pdf") {
                              setPdfFo(fo);
                              // setFileOwner(fo.getOwner());
                              setFileOwner(row.original?.owner ?? "NoData");
                              setPdfFileName(selRow.name);
                              setPdfDupCurrentPath(dupCurrentPath);
                              setShowPDFViewer(true);
                            } else if (fileType === "application/idoc" || fileExtension === "idoc") {
                              const normalizedParent = dupCurrentPath.join("/");
                              const fullPath = `/${normalizedParent}/${fileNameForShared}`.replace(/\/+/g, '/');
                              window.open(`${DOCS_APP_URL}?path=${encodeURIComponent(fullPath)}&name=${encodeURIComponent(selRow.name)}`, "_blank");
                            } else if (fileType === "application/isheet" || fileExtension === "isheet") {
                              const normalizedParent = dupCurrentPath.join("/");
                              const fullPath = `/${normalizedParent}/${fileNameForShared}`.replace(/\/+/g, '/');
                              window.open(`${SHEETS_APP_URL}?path=${encodeURIComponent(fullPath)}&name=${encodeURIComponent(selRow.name)}`, "_blank");
                            } else if (["jpg", "jpeg", "png", "gif", "svg", "webp", "heic", "heif"].includes(fileExtension)) {
                              setImageFo(fo);
                              setFileOwner(row.original?.owner ?? "NoData");
                              setImageFileName(selRow.name);
                              setImageDupCurrentPath(dupCurrentPath);
                              setShowImageViewer(true);
                            } else if (["mp3", "wav", "ogg", "m4a", "flac"].includes(fileExtension)) {
                              setAudioFo(fo);
                              setFileOwner(row.original?.owner ?? "NoData");
                              setAudioFileName(selRow.name);
                              setAudioDupCurrentPath(dupCurrentPath);
                              setShowAudioPlayer(true);
                            } else if (["mp4", "webm", "ogv", "mov", "mkv"].includes(fileExtension)) {
                              setVideoFo(fo);
                              setFileOwner(row.original?.owner ?? "NoData");
                              setVideoFileName(selRow.name);
                              setVideoDupCurrentPath(dupCurrentPath);
                              setShowVideoPlayer(true);
                            } else if (COLLABORA_STATE) {
                              loadCollobora(selRow);
                            }
                          }
                        } catch (error) {
                          showToast(`Failed to load file: ${error}`, "error");
                          console.error("Failed to load file:", error);
                        }
                      }

                    }}
                  >
                    <CollaboraUI collaboraURL={collaboraURL.current} showCollabora={showCollabora} setShowCollabora={setShowCollabora} />
                    {isMobile && layout === "table" ? (
                      <>
                        {!isSharedWithMeRoot ? (
                          <td
                            className="tableBodyRowData mobile-checkbox-cell"
                            style={{ display: "none" }}
                          >
                          </td>
                        ) : <div style={{ display: "none" }}></div>}
                        <td
                          style={{
                            backgroundColor:
                              checkedRows[row.original.name] && isMobile
                                ? "var(--gray-gray-8)"
                                : undefined,
                            display: isMobile ? "flex" : undefined,
                            alignItems: isMobile ? "center" : undefined,
                            justifyContent: isMobile ? "space-between" : undefined,
                            gap: isMobile ? "4px" : undefined,
                            paddingLeft: isMobile ? "8px" : undefined,
                            paddingRight: isMobile ? "0px" : undefined,
                            width: isMobile ? "100%" : undefined,
                          }}
                          className="tableBodyRowData"
                          onClick={() => handleRowClick(row, idx)}
                          onDoubleClick={() => {
                            if (row?.original?.type === "folder") {
                              // Prevent double-click navigation for folders in trash
                              if (activeTab + 1 === 3) {
                                return;
                              }
                              if (currentPath.length == 2 && activeTab + 1 == 2) {
                                handleFolderClick(filesData[idx].uuids);
                                setSelectedFolder(filesData[idx].uuids);
                                handledupFolderClick(row.original.name);
                              }
                              else {
                                handleFolderClick(row.original.name);
                                setSelectedFolder(row.original.name);
                                handledupFolderClick(row.original.name);
                              }
                            }
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", gap: "4px", flex: isMobile ? "0 0 80%" : 1, overflow: "hidden" }}>
                            {!isSharedWithMeRoot && (
                              <div onClick={(e) => e.stopPropagation()} style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                                <SquareCheckBox
                                  label=""
                                  isChecked={checkedRows[row.original.name] || false}
                                  isDisable={false}
                                  onChange={(e) => {
                                    setCheckedRows((prev) => {
                                      const temp = { ...prev };
                                      if (temp[row.original.name]) {
                                        delete temp[row.original.name];
                                      } else {
                                        temp[row.original.name] = row.original.uuids ?? -1;
                                      }
                                      const updatedCheckedRows = { ...temp };
                                      const allChecked =
                                        Object.keys(updatedCheckedRows).length === filesData.length &&
                                        Object.values(updatedCheckedRows).every(Boolean);
                                      setIsAllChecked(allChecked);
                                      return updatedCheckedRows;
                                    });
                                  }}
                                />
                              </div>
                            )}
                            <div className="mobile-name-scroll" style={{ flex: 1, overflowX: isMobile ? "auto" : "hidden", overflowY: "hidden", display: "flex", alignItems: "center" }}>
                              <span key="name" style={{ whiteSpace: "nowrap" }}>
                                {isSharedWithMeRoot
                                  ? row.cells[0].render("Cell")
                                  : row.cells[1]?.render("Cell")}
                              </span>
                            </div>
                          </div>
                          <span key="actions" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", flex: isMobile ? "0 0 20%" : "0 0 auto", flexShrink: 0 }}>
                            {isSharedWithMeRoot
                              ? null
                              : row.cells[5]?.render("Cell")}
                          </span>
                        </td>
                      </>
                    ) : layout === "table" && !isMobile ? (
                      row.cells.map((cell) => {
                        const { key, ...cellProps } = cell.getCellProps();
                        return (
                          <td
                            style={{
                              width: cell.column.width,
                              maxWidth: cell.column.width,
                              flex: `0 0 ${cell.column.width}`,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap"
                            }}
                            className="tableBodyRowData"
                            key={cell.column.id}
                            {...cellProps}
                          >
                            {cell.render("Cell")}
                          </td>
                        );
                      })
                    ) : layout === "grid" && activeTab + 1 !== 3 ? (
                      <td
                        className="gridTableBodyRowData"
                        style={{
                          backgroundColor:
                            checkedRows[row.original.name] &&
                            "var(--gray-gray-8)",
                        }}
                      >
                        <div
                          className="imageBox"
                          style={{
                            backgroundColor:
                              checkedRows[row.original.name] &&
                              "var(--background-bg-normal)"
                          }}
                        >
                          <GridThumbnail
                            fo={row.original.fo}
                            defaultIcon={getFileIcon(row.original.name, row.original.type)}
                            isShared={activeTab + 1 === 2}
                          />

                          {!isSharedWithMeRoot && (
                            <div
                              className={`gridCheckbox ${checkedRows[row.original.name] ? "showCheck" : ""
                                }`}
                              style={{
                                pointerEvents: isMobile && "none"
                              }}
                            >
                              <SquareCheckBox
                                label=""
                                isChecked={
                                  checkedRows[row.original.name] || false
                                }
                                isDisable={false}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  setCheckedRows((prev) => {
                                    const temp = { ...prev };
                                    if (temp[row.original.name]) {
                                      delete temp[row.original.name];
                                    } else {
                                      temp[row.original.name] = row.original.uuids ?? -1;
                                    }
                                    const updatedCheckedRows = {
                                      ...temp
                                    };

                                    // Ensure `isAllChecked` only updates when all rows are checked
                                    const allChecked =
                                      Object.keys(updatedCheckedRows).length ===
                                      filesData.length &&
                                      Object.values(updatedCheckedRows).every(
                                        Boolean
                                      );
                                    setIsAllChecked(allChecked);

                                    return updatedCheckedRows;
                                  });
                                }}
                              />
                            </div>
                          )}
                        </div>

                        <div className="infoWrapper">
                          <div className="infoWrapperLeft">
                            <p className="name">{row.original.name}</p>
                            {/* <span className="gridModified">
                              {row.cells[2].render("Cell")}
                            </span> */}
                          </div>
                          <div className="infoWrapperRight">
                            <div className="imgBox">
                              {/* Safely access cell[5] which might not exist in shared root */}
                              {isSharedWithMeRoot ? null : row.cells[5]?.render("Cell")}
                            </div>
                          </div>
                        </div>

                        {menu.selectedRow == row.id && !isMobile && layout === "grid" && activeTab + 1 !== 3 && (
                          <Portal>
                            <div
                              ref={menuRef}
                              className="menuBox gridMenuBox"
                              style={{
                                position: "fixed",
                                top: gridMenuPosition.top ? `${gridMenuPosition.top}px` : "auto",
                                bottom: gridMenuPosition.top ? "auto" : "auto",
                                right: gridMenuPosition.right !== null ? `${gridMenuPosition.right}px` : "auto",
                                left: gridMenuPosition.left !== null ? `${gridMenuPosition.left}px` : "auto",
                                zIndex: 9999
                              }}
                            >
                              <MenuDropDown
                                list={getMenuItemsForRow(row?.original)}
                                setMenu={setMenu}
                                row={row?.original}
                                id={row?.id}
                                setSelectedRow={setSelectedRow}
                                downloadFile={downloadFile}
                                restoreFromTrash={() => { }}
                                DeleteFromTrash={() => { }}
                                tableMode={layout}
                              />
                            </div>
                          </Portal>
                        )}
                      </td>
                    ) : layout === "grid" && activeTab + 1 === 3 ? (
                      // Grid mode disabled for trash - render as table instead
                      row.cells.map((cell) => (
                        <td
                          style={{
                            width: cell.column.width
                          }}
                          className="tableBodyRowData"
                          key={cell.column.id}
                          {...cell.getCellProps()}
                          onClick={() => setSelectedFolder(row.original)}
                        >
                          {cell.render("Cell")}
                        </td>
                      ))
                    ) : null}

                    {menu.selectedRow == row.id && !isMobile && (layout === "table" || activeTab + 1 === 3) && (
                      <Portal>
                        <div
                          ref={menuRef}
                          className="menuBox"
                          style={{
                            position: "fixed",
                            top: tableMenuPosition.top !== null ? `${tableMenuPosition.top}px` : "auto",
                            right: tableMenuPosition.right !== null ? `${tableMenuPosition.right}px` : "5%",
                            left: tableMenuPosition.left !== null ? `${tableMenuPosition.left}px` : "auto",
                            zIndex: 9999
                          }}
                        >
                          <MenuDropDown
                            list={getMenuItemsForRow(row?.original)}
                            setMenu={setMenu}
                            row={row?.original}
                            id={row?.id}
                            setSelectedRow={setSelectedRow}
                            downloadFile={downloadFile}
                            restoreFromTrash={() => { }}
                            DeleteFromTrash={() => { }}
                            tableMode={layout}
                          />
                        </div>
                      </Portal>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {menu.selectedRow === mobileRow && isMobile && !subDropDown && (
        <Drawer
          isVisible={menu.selectedRow === mobileRow}
          handleCancel={handleCancelSubdropDown}
          showFooter={false}
          showHeader={false}
        >
          <MenuDropDown
            list={getMenuItemsForRow(mobileRowData)}
            setMenu={setMenu}
            setMobileRow={setMobileRow}
            backgroundNone={true}
            setSubDropDown={setSubDropDown}
            subDropDown={subDropDown}
            row={mobileRowData}
            setSelectedRow={setSelectedRow}
            downloadFile={downloadFile}
            restoreFromTrash={() => { }}
            DeleteFromTrash={() => { }}
          />
        </Drawer>
      )}

      {subDropDown ? (
        <Drawer
          isVisible={subDropDown}
          handleCancel={handleCancelSubdropDown}
          showFooter={false}
          showHeader={false}
        >
          <MenuDropDown
            setMenu={setMenu}
            setMobileRow={setMobileRow}
            backgroundNone={true}
            setSubDropDown={setSubDropDown}
            subDropDown={subDropDown}
            row={mobileRowData}
            setSelectedRow={setSelectedRow}
            downloadFile={downloadFile}
            list={filterShareFromMenu([
              { icon: <ListIcons type="details" />, text: "Details" },
              { icon: <ListIcons type="activity" />, text: "Versions" }
            ], mobileRowData)}
          />
        </Drawer>
      ) : (
        ""
      )}

      <PDFViewer
        isVisible={showPDFViewer}
        handleCancel={() => {
          setShowPDFViewer(false);
          setPdfFo(null);
          setPdfFileName("");
          setPdfDupCurrentPath([]);
        }}
        fo={pdfFo}
        fileName={pdfFileName}
        dupCurrentPath={pdfDupCurrentPath}
        fileOwner={fileOwner}
      />

      <ImageViewer
        isVisible={showImageViewer}
        handleCancel={() => {
          setShowImageViewer(false);
          setImageFo(null);
          setImageFileName("");
          setImageDupCurrentPath([]);
        }}
        fo={imageFo}
        fileName={imageFileName}
        dupCurrentPath={imageDupCurrentPath}
      />

      <AudioPlayer
        isVisible={showAudioPlayer}
        handleCancel={() => {
          setShowAudioPlayer(false);
          setAudioFo(null);
          setAudioFileName("");
          setAudioDupCurrentPath([]);
        }}
        fo={audioFo}
        fileName={audioFileName}
        dupCurrentPath={audioDupCurrentPath}
      />

      <VideoPlayer
        isVisible={showVideoPlayer}
        handleCancel={() => {
          setShowVideoPlayer(false);
          setVideoFo(null);
          setVideoFileName("");
          setVideoDupCurrentPath([]);
        }}
        fo={videoFo}
        fileName={videoFileName}
        dupCurrentPath={videoDupCurrentPath}
      />

    </div>

  );
};
export default Table;
